import { http } from '../utils/http'

const editAction = (params,id) => {
  const url = `/open/api/v1/mapping-topic/${id}/update`
  return http.post(url, params)
};
const deleteAction = (id) => {
  const url = `/open/api/v1/mapping-topic/${id}/delDictionary`
  return http.post(url)
};
export default {
  editAction,
  deleteAction,
}
